export default __webpack_public_path__ + "static/media/nice-one.a3588046.gif";